import { getPopupContainer } from '@bimser/core';
import { DatePicker, GetRef } from 'antd';
import dayjs from 'dayjs';
import 'dayjs/locale/az';
import 'dayjs/locale/de';
import 'dayjs/locale/ru';
import 'dayjs/locale/tr';
import 'dayjs/locale/zh';
import localeData from 'dayjs/plugin/localeData';
import React from 'react';
import Styles from './assets/styles.scss';
import { IDatePickerProps } from './entities';
import classNames from 'classnames/bind';
import { BCPortalStyleExtractor } from '../BCPortalStyleExtractor';

dayjs.extend(localeData);
const cx = classNames.bind(Styles);

type BCDatePickerRef = GetRef<typeof DatePicker>;

const BCDatePicker = React.memo(
	React.forwardRef<BCDatePickerRef, IDatePickerProps>(function BCDatePicker(props, ref) {
		Styles;

		const onChange = (date: dayjs.Dayjs, dateString: string) => {
			if (props.onChange) {
				const shortISODate = dayjs(date).format().split('T')[0];
				const longISODate = dayjs(date).format().split('+')[0];
				const dateTimeOffsetString = dayjs(date).format();
				props.onChange(
					date,
					date && date.format(),
					dateString,
					shortISODate,
					longISODate,
					dateTimeOffsetString
				);
			}
		};

		const className = cx({
			datePickerStyles: true,
			textalignRight: props.textAlign === 'right',
			textalignLeft: props.textAlign === 'left',
			textalignCenter: props.textAlign === 'center'
		});

		const renderPicker = () => (
			<DatePicker
				autoFocus={props.autoFocus}
				className={[className, props.className].join(' ')}
				defaultValue={props.defaultValue}
				onChange={onChange}
				placeholder={props.placeholder}
				size={props.size}
				disabled={props.disabled}
				disabledDate={props.disabledDate}
				showTime={props.showTime}
				format={props.format || dayjs().localeData().longDateFormat('L')}
				style={props.style}
				value={props.value}
				ref={ref}
				onBlur={props.onBlur}
				onFocus={props.onFocus}
				onKeyDown={props.onKeyDown}
				allowClear={props.allowClear && !props.readOnly}
				getPopupContainer={props.getPopupContainer || getPopupContainer}
				open={props.readOnly ? false : undefined}
				inputReadOnly={props.inputReadOnly || props.readOnly}
				disabledTime={props.disabledTime}
				popupClassName={props.popupClassName}
				data-selenium-id={props.seleniumId}
				showNow={props.showNow || props.showToday}
				minDate={props.minDate}
				maxDate={props.maxDate}
			/>
		);

		if (props.extractPopupKey) {
			return (
				<BCPortalStyleExtractor extractPopupKey={props.extractPopupKey}>
					{renderPicker()}
				</BCPortalStyleExtractor>
			);
		}

		return renderPicker();
	})
);

export default BCDatePicker;
export { BCDatePickerRef, IDatePickerProps };
